import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'abc-footer',
	templateUrl: './abc-footer.component.html',
	styleUrls: ['./abc-footer.component.css']
})
export class AbcFooterComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

}
